import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div className="sun-layer">
        <div className="sun">
        </div>
        <div className="sun-2">
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Sun.js